import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {onlyToast} from 'hiya-common/src/App/CustomToaster'
import {setLocalMusic} from './constant'
import {mock_spin_result, mock_rotate_spin_reulst} from './mockdata'
import {
  WildStateStatus,
  BoardCardEnum,
  BoardItem,
  RoyalWildElement,
  RoyalWildHoldSpinInfo,
  RoyalWildTumble,
  RoyalWildJackpot,
  RoyalWildNewerTask,
  WinTypeEnum,
  FreePlayInfo,
  RoyalWildTop,
  ProcessStatusEnum,
  RoyalWildHoldSpinTumble,
  RoyalWildJackpotPool,
} from './interface'

// 新手任务 http://wiki.xunlei.cn/pages/viewpage.action?pageId=167798412
export const royal_wild_newer_task = createAsyncThunk(
  'royal_wild_newer_task',
  async (arg: any, store) => {
    const resp = await http.post(
      '/live/ground/r_w_newer_task',
      {
        ...arg,
        pre_load: store.getState().env.otherInfo.from === 'config_preload',
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 主页 http://wiki.xunlei.cn/pages/viewpage.action?pageId=167798400
export const royal_wild_homepage = createAsyncThunk(
  'royal_wild_homepage',
  async (arg: {room_id: number}, store: any) => {
    const resp = await http.post(
      '/live/ground/r_w_homepage',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
        pre_load: store.getState().env.otherInfo.from === 'config_preload',
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// spin http://wiki.xunlei.cn/pages/viewpage.action?pageId=167798403
export const royal_wild_spin = createAsyncThunk(
  '/live/ground/r_w_spin',
  async (
    arg: {
      room_id: number
      bet_amount: number
      is_free_spin: boolean
      is_auto_mod: boolean
      is_quick_mod: boolean
      is_free_card: boolean
    },
    store: any
  ) => {
    const resp = await http.post(
      '/live/ground/r_w_spin',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// hold spin http://wiki.xunlei.cn/pages/viewpage.action?pageId=167798403
export const royal_wild_hold_spin = createAsyncThunk(
  '/live/ground/r_w_hold_spin',
  async (arg: any, store: any) => {
    const resp = await http.post(
      '/live/ground/r_w_hold_spin',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// http://wiki.xunlei.cn/pages/viewpage.action?pageId=167803320
export const royal_wild_hold_spin_result = createAsyncThunk(
  '/live/ground/r_w_hold_spin_result',
  async (arg: any, store: any) => {
    const resp = await http.post(
      '/live/ground/r_w_hold_spin_result',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

interface FreeCardInfo {
  // 金币卡信息
  value: number // 	面值
  num: number //	数量
}

interface InitialStateType {
  // 本地控制
  config?: {
    isGuide: boolean // 新手引导标志
    hasPreLoadedAct: boolean // 前置加载引导标志
    isLoading: boolean // 加载标志
    playMusic: boolean // 播放音乐
    is_auto_mod: boolean // 开始自动模式 仅在摇奖开始和结束变化
    pre_auto_mod: boolean // 是否勾选auto
    is_quick_mod: boolean // 快速模式
    bet_num: number // 下注金额
    bet_lock: boolean // 下注控制
    auto_hold_spin?: boolean // 是否是自动hold_spin
  }
  // home接口信息
  home?: {
    bet_coins?: Array<number> // 可选的下注金额
    elements?: Array<RoyalWildElement> // 规则使用
    combo_multipliers?: Array<number> // 连击倍率
    jackpot_pool?: Array<RoyalWildJackpotPool>
    init_board?: Array<Array<BoardItem>> // 初始棋盘
    balance?: number // 剩余金币
    rec_amount?: number // 推荐金币，不存在默认时使用
    free_play?: FreePlayInfo
    free_card?: FreeCardInfo[]
    pending_hold_spin?: RoyalWildHoldSpinInfo // 中断的 hold&spin 信息, 可能为 null
    week_top1?: RoyalWildTop // 榜1
    hold_spin_countdown?: number // holdspin倒计时 统一数据存放在这里保证倒计时实时性
  }
  // spin 接口信息
  spin?: {
    free_card?: FreeCardInfo[]
    free_play?: number
    balance?: number
    tumbles?: Array<RoyalWildTumble>
    mini_jackpot?: RoyalWildJackpot
    major_jackpot?: RoyalWildJackpot
    grand_jackpot?: RoyalWildJackpot
    total_win?: number
    win_type?: WinTypeEnum
    hold_spin?: RoyalWildHoldSpinInfo
  }
  // 新手任务
  newerTask?: RoyalWildNewerTask
  // result 结果展示 --- 补牌后才可以改变结果展示
  result?: {
    result_info?: RoyalWildTumble // 结果棋盘
    next_result?: RoyalWildTumble // 下一个结果棋盘
    result_idx?: number
    process_status: ProcessStatusEnum // 流程状态
    // 1.正常模式 2.滚动模式 3.奖励 4.补牌 5.奖励 6.补牌 。。。。。。。
  }
  // holdSpin 接口信息
  holdSpin?: {
    new_board?: Array<Array<BoardItem>> // 棋盘
    spins?: number // 剩余 spins 次数
    hold_coords?: Array<Array<number>> // 固定位置
    win_amount?: number
    mini_jackpot?: RoyalWildJackpot
    major_jackpot?: RoyalWildJackpot
    grand_jackpot?: RoyalWildJackpot
    total_win?: number
    balance?: number
    win_type?: WinTypeEnum
    tumbles?: Array<RoyalWildHoldSpinTumble>
    cur_spin_id?: number // 当前tumbles的下标
  }
  // holdSpinResult 接口信息
  holdSpinResult?: {
    tumbles?: Array<RoyalWildHoldSpinTumble>
    win_amount?: number
    mini_jackpot?: RoyalWildJackpot
    major_jackpot?: RoyalWildJackpot
    grand_jackpot?: RoyalWildJackpot
    total_win?: number
    win_type?: WinTypeEnum
    balance?: number
  }
  test?: {
    scroll: boolean
  }
}
const initData = {
  // 本地控制
  config: {
    isGuide: false,
    hasPreLoadedAct: false,
    isLoading: true,
    playMusic: true,
    is_auto_mod: false, // 自动模式
    pre_auto_mod: false,
    is_quick_mod: false, // 快速模式
    bet_num: 0,
    bet_lock: false,
  },
  // home接口信息
  home: {},
  spin: {},
  result: {
    result_info: null,
    next_result: null,
    result_idx: 0,
    // 1.正常模式 2.滚动模式 3.奖励 4.补牌 5.奖励 6.补牌 。。。。。。。
    process_status: ProcessStatusEnum.normal,
  },
  newerTask: {
    status: 0,
    is_red: false,
    countdown: 0, // 倒计时
    daily_countdown: 0, // 每日倒计时
    task_list: [], // 任务列表
    main_stages: [], // 任务阶段
    total_points: 0, // 累计点数
  },
  holdSpin: {},
  holdSpinResult: {},
  test: {
    scroll: false,
  },
}
const initialState: InitialStateType = {}

// =============== 长链接数据处理
const messageReducers = {
  // 更新长链接信息 handle241 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90612536
  updateMessageInfo: (state, action) => {
    Object.assign(state.home, {
      ...action.payload,
    })
  },
}

// ============== HoldSpin | Spin 通用数据处理
const generalSpinHoldSpinReducers = {
  SetEnd: (state) => {
    const {spin, holdSpin, holdSpinResult} = state
    const isholdSpinEnd = holdSpin && holdSpin?.spins === 0 // hold spin结束

    Object.assign(state, {
      spin: {},
      holdSpin: {},
      home: {
        ...state.home,
        init_board:
          state?.spin?.tumbles?.[state?.spin?.tumbles?.length - 1]?.new_board ||
          holdSpin?.new_board,
        balance: spin?.balance || holdSpin?.balance || holdSpinResult?.balance,
        free_play: isholdSpinEnd
          ? state.home.free_play
          : state?.spin?.free_play,
        free_card: isholdSpinEnd
          ? state.home.free_card
          : state?.spin?.free_card,
        pending_hold_spin: {},
      },
      holdSpinResult: {},
      result: {
        result_info: null, // 结果棋盘
        next_result: null, // 下一个结果棋盘
        result_idx: 0,
        process_status: ProcessStatusEnum.normal,
      },
    })
  },
  // 游戏弹窗结束执行 -》 spin的结束 || holdSpin结束
  PlayDone: (state) => {
    const {spin, holdSpin, holdSpinResult} = state
    const isholdSpinEnd = holdSpin && holdSpin?.spins === 0 // hold spin结束

    if (state?.result?.process_status === ProcessStatusEnum.show_reward) {
      // 更新初始牌和pending_hold_spin 参数
      Object.assign(state.home, {
        init_board:
          state?.spin?.tumbles?.[state?.spin?.tumbles?.length - 1]?.new_board ||
          holdSpin?.new_board,
        balance: spin?.balance || holdSpin?.balance || holdSpinResult?.balance,
      })
      // 判断是否存在hold_spin
      if ((spin?.hold_spin?.spins || holdSpin?.spins) > 0) {
        Object.assign(state.result, {
          process_status: ProcessStatusEnum.hold_spin_init,
        })
        Object.assign(state.config, {
          bet_num: state?.spin?.hold_spin?.bet,
        })
      } else {
        // 完全结束 数据初始化
        Object.assign(state, {
          spin: {},
          holdSpin: {},
          home: {
            ...state.home,
            init_board:
              state?.spin?.tumbles?.[state?.spin?.tumbles?.length - 1]
                ?.new_board || holdSpin?.new_board,
            balance:
              spin?.balance || holdSpin?.balance || holdSpinResult?.balance,
            free_play: isholdSpinEnd
              ? state.home.free_play
              : state?.spin?.free_play,
            free_card: isholdSpinEnd
              ? state.home.free_card
              : state?.spin?.free_card,
            pending_hold_spin: {},
          },
          holdSpinResult: {},
          result: {
            result_info: null, // 结果棋盘
            next_result: null, // 下一个结果棋盘
            result_idx: 0,
            process_status: ProcessStatusEnum.normal,
          },
        })
      }
    }
  },
}

// ------ 测试reducer
const testReducer = {
  changeProcessStatus: (state, action) => {
    const spin_result = mock_spin_result
    // action.payload === ProcessStatusEnum.win
    //   ? mock_rotate_spin_reulst
    //   : mock_spin_result
    Object.assign(state.result, {
      process_status: action.payload,
      result_info: spin_result?.tumbles?.[0],
      next_result: spin_result?.tumbles?.[1] || null,
      result_idx: 0,
    })
    Object.assign(state.spin, {
      ...spin_result,
    })
    Object.assign(state.test, {
      scroll: true,
    })
  },
}

// ============== HoldSpin 数据处理
const holdSpinReducers = {
  // ______ 通用数据处理
  // holdSpin 玩一次spins减1（必须替换为新对象才能触发 UI 重渲染）
  reduceHoldSpins: (state, action) => {
    Object.assign(state.home.pending_hold_spin, {
      ...(state.home.pending_hold_spin || {}),
      spins: action.payload - 1,
    })
  },
  // ______ 自动情况数据处理
  // 自动开holdspin奖开始，且当前不在开奖时
  HoldSpinResult: (state, action) => {
    const {tumbles} = action.payload
    const info = tumbles?.[0]
    Object.assign(state.holdSpin, {
      new_board: info?.new_board,
      spins: info?.spins,
      hold_coords: info?.hold_coords,
      ...action.payload,
      cur_spin_id: 0,
    })
    Object.assign(state.result, {
      process_status: ProcessStatusEnum.hold_spin_scroll,
    })
  },
  // ______ 正常holdSpin数据处理
  // holdspin展示奖励结束 action: holdSPin
  holdSpinRewardEnd: (state, action) => {
    // 判断holdspin是否结束
    const {spins, new_board, hold_coords, tumbles, cur_spin_id} = action.payload
    const {config} = state
    // 次数存在 没结束
    if (spins > 0) {
      // 是否是自动spin情况
      // 也可能从-1开始
      const curSpinId = cur_spin_id ?? -1
      if (config?.auto_hold_spin && curSpinId < tumbles?.length - 1) {
        // 自动开始执行下一个
        const index = cur_spin_id + 1
        const info = tumbles?.[index]
        Object.assign(state.holdSpin, {
          ...action.payload,
          new_board: info?.new_board,
          spins: info?.spins,
          hold_coords: info?.hold_coords,
          cur_spin_id: index,
        })
        Object.assign(state.result, {
          process_status: ProcessStatusEnum.hold_spin_scroll,
        })
        Object.assign(state.config, {
          auto_hold_spin: true,
        })
        // 更新home数据
        Object.assign(state.home, {
          init_board: new_board,
          pending_hold_spin: {
            ...state.home.pending_hold_spin,
            spins, // 剩余spin次数
            board: new_board, // 棋盘
            hold_coords, // 固定的坐标
          },
        })
      } else {
        // 不存在自动逻辑
        Object.assign(state.result, {
          process_status: ProcessStatusEnum.hold_spin,
        })
        // 更新home数据
        Object.assign(state.home, {
          init_board: new_board,
          pending_hold_spin: {
            ...state.home.pending_hold_spin,
            spins, // 剩余spin次数
            board: new_board, // 棋盘
            hold_coords, // 固定的坐标
          },
        })
      }
    } else {
      // 次数不存在，展示结果弹窗，更新数据
      Object.assign(state.result, {
        process_status: ProcessStatusEnum.show_reward,
      })
      Object.assign(state.home, {
        init_board: new_board,
        pending_hold_spin: {
          ...state.home.pending_hold_spin,
          spins, // 剩余spin次数
          board: new_board, // 棋盘
          hold_coords, // 固定的坐标
        },
      })
      Object.assign(state.config, {
        auto_hold_spin: false,
      })
    }
  },
  // hold spin 补牌完成后～
  HoldSpinDone: (state, action) => {
    const {hold_coords, new_board} = action.payload || {}
    Object.assign(state.result, {
      process_status: ProcessStatusEnum.hold_spin_reward,
    })
    Object.assign(state.home, {
      init_board: new_board || state?.home?.init_board,
      hold_coords: hold_coords || state?.home?.pending_hold_spin.hold_coords,
    })
  },
  // hold spin 初始化后～
  holdSpinInitEnd: (state) => {
    // 消除后需要补牌---
    Object.assign(state.result, {
      result_info: null, // 结果棋盘
      next_result: null, // 下一个结果棋盘
      result_idx: 0,
      process_status: ProcessStatusEnum.hold_spin,
    })
    Object.assign(state.home, {
      init_board: state?.spin?.hold_spin?.board,
      pending_hold_spin: state?.spin?.hold_spin,
    })
    Object.assign(state, {
      spin: {},
    })
  },
}

//  ============== Spin 数据处理
const spinReducers = {
  // spin 下的comb结束～
  CombDone: (state) => {
    // 消除后需要补牌---
    const {result, spin} = state
    const {tumbles} = spin
    const {result_idx} = result
    const curIdx = result_idx + 1
    Object.assign(state.home, {
      init_board: tumbles?.[curIdx]?.new_board,
    })
    // 判断是否中奖展示后面动画
    if (tumbles?.length - 1 > curIdx) {
      // 中奖-展示动画
      Object.assign(state.result, {
        result_info: tumbles?.[curIdx],
        next_result: tumbles?.[curIdx + 1],
        result_idx: curIdx,
        process_status: ProcessStatusEnum.win,
      })
    } else {
      // 结束 展示comb
      Object.assign(state.result, {
        process_status: ProcessStatusEnum.show_reward,
      })
    }
  },
  // spin 下消除完成调用～
  ComplateCancel: (state) => {
    // 消除后需要补牌---
    Object.assign(state.result, {
      process_status: ProcessStatusEnum.add_card,
    })
  },
  // spin 下落动画完成调用～
  SpinDone: (state) => {
    const {result, spin} = state
    const {tumbles} = spin
    const {result_idx} = result

    // 下落完变成初始卡牌变成0卡牌
    Object.assign(state.home, {
      init_board: spin?.tumbles?.[result_idx]?.new_board,
    })
    // 判断是否中奖展示后面动画
    if (tumbles?.length - 1 > result_idx) {
      // 中奖-展示动画
      Object.assign(state.result, {
        process_status: ProcessStatusEnum.win,
      })
    } else {
      // 结束
      Object.assign(state.result, {
        process_status: ProcessStatusEnum.show_reward,
      })
    }
  },
  // spin 补牌完成调用～
  AddDone: (state) => {
    const {result} = state
    const {result_idx} = result
    Object.assign(state.home, {
      init_board: state?.spin?.tumbles?.[result_idx + 1]?.new_board,
    })
    Object.assign(state.result, {
      process_status: ProcessStatusEnum.show_comb,
    })
  },
}

// ============== 功能设置型reducer
const configReducers = {
  // 前置流程完成标记
  finishedPreLoadedAct: (state) => {
    Object.assign(state.config, {
      hasPreLoadedAct: true,
    })
  },
  // 引擎加载完毕之后隐藏加载页面
  finishedLoading: (state) => {
    Object.assign(state.config, {
      isLoading: false,
    })
  },
  // 设置下注锁 锁所有
  changeBetLock: (state, action) => {
    Object.assign(state.config, {
      bet_lock: action.payload,
    })
  },
  // 切换快速模式
  ChangeQuick: (state) => {
    Object.assign(state.config, {
      is_quick_mod: !state.config.is_quick_mod,
    })
  },
  // 切换自动下注
  ChangeAuto: (state, action) => {
    Object.assign(state.config, {
      pre_auto_mod: action.payload,
    })
  },
  StartAuto: (state, action) => {
    Object.assign(state.config, {
      is_auto_mod: action.payload,
    })
  },
  // 切换音效
  ChangePlayMusic: (state) => {
    setLocalMusic(!state.config.playMusic)
    Object.assign(state.config, {
      playMusic: !state.config.playMusic,
    })
  },
  // 改变下注金额
  changeBet: (state, action) => {
    // 处于免费玩不能更改下注
    if (!state?.config?.bet_lock) {
      Object.assign(state.config, {
        bet_num: action.payload,
      })
    }
  },
  // 改变下注金额(金币卡调用)
  changeBetByFreeCard: (state, action) => {
    Object.assign(state.config, {
      bet_num: action.payload,
    })
  },
  // 新手引导
  setGuide: (state, action) => {
    Object.assign(state.config, {
      isGuide: action.payload,
    })
  },
}

export const RoyalWildSlice = createSlice({
  name: 'RoyalWild',
  initialState,
  reducers: {
    ...messageReducers,
    ...generalSpinHoldSpinReducers,
    ...holdSpinReducers,
    ...spinReducers,
    ...configReducers,
    ...testReducer,
    initData: (state, action) => {
      Object.assign(state, initData)
    },
  },
  extraReducers: (builder) => {
    // 主页
    builder.addCase(royal_wild_homepage.fulfilled, (state, action) => {
      const {pending_hold_spin, init_board, card_list} = action.payload
      const {process_status} = state.result
      const {
        init_board: home_init_board,
        pending_hold_spin: home_pending_hold_spin,
      } = state.home
      if (state.config?.auto_hold_spin) return
      Object.assign(state.home, {
        ...action.payload,
        free_card: card_list,
        init_board:
          process_status !== ProcessStatusEnum.normal
            ? home_init_board
            : init_board,
        // 防止在hold_spin中时改变hold_spin数据
        pending_hold_spin:
          process_status >= ProcessStatusEnum.hold_spin
            ? home_pending_hold_spin
            : pending_hold_spin,
      })
      // 是不是处于hold_spin状态
      if (pending_hold_spin?.spins) {
        if (state.result?.process_status === ProcessStatusEnum.normal) {
          Object.assign(state.result, {
            process_status: ProcessStatusEnum.hold_spin,
          })
        }
        Object.assign(state.home, {
          init_board: pending_hold_spin?.board,
          hold_spin_countdown: pending_hold_spin?.countdown,
        })
      }
    })
    builder.addCase(royal_wild_spin.fulfilled, (state, action) => {
      const {
        status,
        spin_result,
        balance,
        free_play,
        card_list,
        bet_amount,
        pay_amount, // 下注实际扣减金额
        err_msg,
      } = action.payload
      // 1成功 2 余额不足
      if (status === 1) {
        Object.assign(state.spin, {
          ...spin_result,
          balance,
          free_play,
          free_card: card_list,
        })
        Object.assign(state.home, {
          balance: state.home?.balance - (pay_amount || 0),
          hold_spin_countdown: spin_result?.hold_spin?.countdown,
        })
        Object.assign(state.result, {
          result_info: spin_result?.tumbles?.[0],
          next_result: spin_result?.tumbles?.[1] || null,
          result_idx: 0,
          process_status: ProcessStatusEnum.scroll,
        })
      } else {
        onlyToast(err_msg)
      }
    })
    builder.addCase(royal_wild_hold_spin.fulfilled, (state, action) => {
      const {err_msg, ...rest} = action.payload
      // // 1成功 2 已过期
      if (rest?.status === 1) {
        Object.assign(state.holdSpin, rest)
        Object.assign(state.result, {
          process_status: ProcessStatusEnum.hold_spin_scroll,
        })
      }
    })
    builder.addCase(royal_wild_hold_spin_result.fulfilled, (state, action) => {
      const {err_msg, game_status} = action.payload
      // // 1成功 2 余额不足
      if (err_msg) {
        onlyToast('err_msg')
      } else if (game_status === 1) {
        Object.assign(state.holdSpinResult, {
          ...action.payload,
        })
        Object.assign(state.config, {
          auto_hold_spin: true,
        })
      }
    })
    // 新手任务
    builder.addCase(royal_wild_newer_task.fulfilled, (state, action) => {
      const {task_list} = action.payload
      Object.assign(state.newerTask, {
        ...action.payload,
        daily_red: !!task_list?.find(
          (ite) => ite?.type === 1 && ite?.status === 1
        ),
        total_red: !!task_list?.find(
          (ite) => ite?.type === 2 && ite?.status === 1
        ),
      })
    })
  },
})

export default RoyalWildSlice.reducer
export const RoyalWildActions = RoyalWildSlice.actions
export const useGameRoyalWild = () => {
  return useSelector((state) => state.Animal_Flamingo)
}
